import React from "react";
import Cookies from "universal-cookie";
import _ from "lodash";
import Raven from "raven-js";
import CONFIG from "../config";
// import API from "../services";
import JSEncrypt from "./JSEncrypt.js";

const cookies = new Cookies("");

if (typeof window === "undefined") {
  global.window = {};
}

CONFIG.BASE_IMG_URL = CONFIG.BASE_IMG_URL || "https://k.nooncdn.com/";

CONFIG.COOKIE_DOMAIN =
  window.location.hostname
    .split(".")
    .slice(-2)
    .join(".") === "localhost"
    ? window.location.hostname
        .split(".")
        .slice(-2)
        .join(".")
    : "." +
      window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");

const COOKIE_DOMAIN =
  window.location.hostname
    .split(".")
    .slice(-2)
    .join(".") === "localhost"
    ? window.location.hostname
        .split(".")
        .slice(-2)
        .join(".")
    : "." +
      window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");

const Helper = {
  getTransformationUrl: function(
    imageKey,
    location = "pdp",
    browser = "desktop",
    version = 1
  ) {
    const ext = "jpg";
    const transformationType = `${browser}-${location}-v${version}`;
    return `${
      imageKey ? CONFIG.BASE_IMG_URL : "https://k.nooncdn.com/"
    }t_${transformationType}/${imageKey || "default"}.${ext}`;
  },
  isValidInput(value) {
    return !value || _.trim(value, "!@#$%^&*)(+=._- ").length < 1;
  },
  buildUrl: function(objectArray) {
    let qs = "";
    let url = "";
    for (const key in objectArray) {
      if (!key) {
        continue;
      }
      const value = objectArray[key];
      qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (qs.length > 0) {
      qs = qs.substring(0, qs.length - 1); // chop off last "&"
      url = url + "?" + qs;
    }
    return url;
  },
  merge(arr1, arr2, key) {
    var criteria = {};
    criteria[key] = null;
    return _.map(arr1, function(item) {
      criteria[key] = item[key];
      return _.merge(item, _.find(arr2, criteria));
    });
  },
  percent(numerator, denominator) {
    if (denominator !== 0) {
      return numerator * 100 / denominator;
    }
  },
  formatPrice(value, currency) {
    return {
      currency: currency,
      value: value
    };
  },
  refresh: function() {
    window.location.reload();
  },
  toggleItemInArray(arr = [], item) {
    const itemIndex = arr.indexOf(item);
    if (itemIndex === -1) {
      arr = [item].concat(arr);
    } else {
      arr.splice(itemIndex, 1);
    }
    return arr;
  },
  buildArray: function(filter) {
    const queryParams = filter.slice(1).split("&");
    const filterArray = {};

    for (let i = 0; i < queryParams.length; i++) {
      const p = queryParams[i];
      // Step 2: Split Key/Value pair
      const keyValuePair = p.split("=");

      // Step 3: Add Key/Value pair to filterArray object
      const key = keyValuePair[0];
      let value = keyValuePair[1];

      // decode URI encoded string
      value = decodeURIComponent(value);
      value = value.replace(/\+/g, " ");

      filterArray[key] = value;
    }

    // Step 4: Return filterArray Object
    return filterArray;
  },
  // check if the two passed object are identical to each other
  isEquivalent(a, b) {
    // Create arrays of property names
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
      return false;
    }

    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
  },
  nl2br: function(text) {
    const converted = text.split("\n").map(function(item, key) {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      );
    });
    return converted;
  },
  clone: function(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }
    const copy = obj.constructor();
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = obj[attr];
      }
    }
    return copy;
  },
  getLoginURL() {
    if (process.browser && window) {
      const loc = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      return `https://login.${loc}`;
    }

    return CONFIG.LOGIN_URL;
  },
  getGtmCategory: function(path) {
    if (!path) {
      return null;
    }

    let nodes = "";
    let node = path;

    // eslint-disable-next-line
    while (true) {
      if (node.name) {
        nodes += node.name + "/";
      }
      if (node.category) {
        node = node.category;
      } else {
        break;
      }
    }
    return nodes;
  },
  gtmBannerClick(item, index) {
    if (window && window.dataLayer && item && index !== undefined) {
      window.dataLayer.push({
        event: "promotionClick",
        ecommerce: {
          promoClick: {
            promotions: [
              {
                name: item.title || "Banner_" + index,
                creative: item.src,
                position: index
              }
            ]
          }
        }
      });
    }
  },
  gtmBannerImpressions(banners) {
    if (window && window.dataLayer && banners && banners.length) {
      window.dataLayer.push({
        ecommerce: {
          promoView: {
            promotions: banners
          }
        },
        event: "bannerImpressions"
      });
    }
  },
  getProductUrl(product, locale) {
    if (!product) {
      return "/";
    } else {
      const productUrl =
        (locale ? locale + "/" : "") +
        (product.url || "product") +
        "/" +
        product.sku +
        "/p" +
        (product.offerCode && product.offer_code !== ""
          ? "?o=" + product.offerCode
          : "");
      return `${CONFIG.HOME_URL}/${productUrl}`;
    }
  },

  getStatusNr(status, fmIntegrated) {
    let statusText = 1;
    switch (status) {
      case "new":
        statusText = 1;
        break;
      case "accepted":
        statusText = 2;
        break;
      case (fmIntegrated && "readyforpickup") || (!fmIntegrated && "completed"):
        statusText = 3;
        break;
      case (fmIntegrated && "picked") || (!fmIntegrated && "cancelled"):
        statusText = 4;
        break;
      case (fmIntegrated && "received") || (!fmIntegrated && "returns"):
        statusText = 5;
        break;

      case fmIntegrated && "completed":
        statusText = 6;
        break;

      case fmIntegrated && "cancelled":
        statusText = 7;
        break;
      case fmIntegrated && "returns":
        statusText = 8;
        break;
      default:
        statusText = 1;
    }
    return statusText;
  },

  getSellURL() {
    const isBrowser: boolean = typeof window !== "undefined";
    // process.browser && window
    if (isBrowser) {
      const loc = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      return `https://sell.${loc}/`;
    }

    return "https://sell.noon.partners";
  },

  getWarehouseURL() {
    const isBrowser: boolean = typeof window !== "undefined";
    // process.browser && window
    if (isBrowser) {
      const loc = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      return `https://warehouse.${loc}/`;
    }

    return "https://warehouse.noon.partners";
  },
  getSubdomain(subdomain) {
    const isBrowser: boolean = typeof window !== "undefined";
    // process.browser && window
    if (isBrowser) {
      const loc = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      return `https://${subdomain}.${loc}/`;
    }

    return "https://sell.noon.partners";
  },

  getIntelURL() {
    const isBrowser: boolean = typeof window !== "undefined";
    // process.browser && window
    if (isBrowser) {
      const loc = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      return `https://intel.${loc}/`;
    }

    return "https://intel.noon.partners";
  },

  getStatusText(status, fmIntegrated) {
    let statusText = "new";
    switch (status) {
      case 1:
        statusText = "new";
        break;
      case 2:
        statusText = "accepted";

        break;
      case fmIntegrated && 3:
        statusText = "readyforpickup";

        break;
      case fmIntegrated && 4:
        statusText = "picked";

        break;
      case fmIntegrated && 5:
        statusText = "received";

        break;

      case fmIntegrated ? 6 : 3:
        statusText = "completed";
        break;
      case fmIntegrated ? 7 : 4:
        statusText = "cancelled";
        break;
      case fmIntegrated ? 8 : 5:
        statusText = "returns";
        break;
      default:
        statusText = "new";
    }
    return statusText;
  },

  validator(data) {
    const haveItemNr =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.item_nr);
    const haveRefNr =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.ref_nr);
    const haveSku =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.sku);
    const havePSkuUnique =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && asn.partner_sku_unique);
    const isReceived =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.is_received);
    const haveReturnAsn =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && asn.return_asn) &&
      isReceived;
    const haveParentAsn =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.parent_asn);
    const haveStatus =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && asn.status && asn.status !== "-");
    const havePSku =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.partner_sku);
    const haveName =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.title);
    const haveRejectReason =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.reject_reason);
    const haveQty =
      data && !_.isEmpty(data) && data.find(asn => asn && Number(asn.qty) >= 0);

    const haveRtv = data && data.find(asn => asn && asn.partner_rtv_nr);
    const haveAsn = data && data.find(asn => asn && asn.asn_nr);

    const haveZoneCode = data && data.find(asn => asn && asn.zone_code);
    const haveZoneClass = data && data.find(asn => asn && asn.zone_class);
    const haveShippedAt = data && data.find(asn => asn && asn.shipped_at);

    const haveWhTo =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.warehouse_to);
    const haveWhFrom =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.warehouse_from);
    const haveQtyRecv =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_recv || asn.qty_received) >= 0);
    const haveQtyNotRecv =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_not_received) >= 0);
    const haveQtyQCRejected =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_qc_rejected) >= 0);
    const haveApprovedQty =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_approved) >= 0);
    const haveRejectedQty =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_rejected) >= 0);
    const haveUnidentifiedQty =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_unidentified) >= 0);
    const haveQtyExp =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_expected) >= 0);
    const haveQtySent =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_sent) >= 0);
    const haveQtyExcess =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && Number(asn.qty_excess) >= 0);
    const havePickedAt =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.picked_at);
    const haveReceivedAt =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.received_at);
    const haveScheduledAt =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.scheduled_at);
    const havePostedAt =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.posted_at);
    const haveWhCode =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.warehouse_code);
    const haveIncomingSkuUnique =
      data &&
      !_.isEmpty(data) &&
      data.find(asn => asn && asn.incoming_skunique !== null);

    const haveReasonCode =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.reason_code);
    const haveBoxBarcode =
      data && !_.isEmpty(data) && data.find(asn => asn && asn.barcode_box);
    const haveItems =
      data && !_.isEmpty(data) && data.find(item => item && item.items);
    const haveAreaCode =
      data && !_.isEmpty(data) && data.find(item => item && item.area_code);
    const havePendingQty =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item.pending_qty) >= 0);
    const havePicklistNr =
      data && !_.isEmpty(data) && data.find(item => item && item.picklist_nr);
    const haveCreatedAt =
      data && !_.isEmpty(data) && data.find(item => item && item.created_at);
    const haveFulfilmentDate =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.fulfilment_date);
    const haveInvoiceDate =
      data && !_.isEmpty(data) && data.find(item => item && item.invoice_date);
    const haveShippedDate =
      data && !_.isEmpty(data) && data.find(item => item && item.shipped_date);
    const haveOriginCountry =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.warehouse_name);
    const haveDestinationCountry =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.customer_country_code);
    const havePartnerSkuUnique =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.partner_sku_unique);
    const haveTotal =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item.qty_total) >= 0);
    const haveReason =
      data && !_.isEmpty(data) && data.find(item => item && item.reason);
    const haveDamageQty =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item.qty_damaged) >= 0);
    const haveQtySoh =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item.qty_soh) >= 0);
    const haveSlot =
      data && !_.isEmpty(data) && data.find(item => item && item.slot);

    const haveIsDelivered =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item.is_delivered) >= 0);

    const haveTicketNr =
      data && !_.isEmpty(data) && data.find(item => item && item.ticket_nr);
    const haveDisputeType =
      data && !_.isEmpty(data) && data.find(item => item && item.dispute_type);
    const haveClosedAt =
      data && !_.isEmpty(data) && data.find(item => item && item.closed_at);
    const haveDocNr =
      data && !_.isEmpty(data) && data.find(item => item && item.ref_to);
    const haveAmount =
      data && !_.isEmpty(data) && data.find(item => item && item.amount);
    const haveStatementNr =
      data && !_.isEmpty(data) && data.find(item => item && item.statement_nr);
    const haveResolutionAmt =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.resolution_amount);
    const haveDisputeReason =
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && item.dispute_reason);
    const haveQtyVal = key =>
      data &&
      !_.isEmpty(data) &&
      data.find(item => item && Number(item[key]) >= 0);
    const haveVal = key =>
      data && !_.isEmpty(data) && data.find(item => item && item[key]);

    const property = {
      haveItemNr,
      haveRefNr,
      haveSku,
      haveParentAsn,
      haveReturnAsn,
      haveStatementNr,
      haveAmount,
      haveStatus,
      havePSku,
      haveName,
      haveRejectReason,
      haveQty,
      haveWhTo,
      haveWhFrom,
      haveRtv,
      haveZoneCode,
      haveZoneClass,
      haveShippedAt,
      haveQtyRecv,
      haveQtyNotRecv,
      haveQtyExp,
      haveWhCode,
      haveReceivedAt,
      havePickedAt,
      haveAsn,
      haveQtySent,
      haveScheduledAt,
      havePostedAt,
      haveIncomingSkuUnique,
      haveReasonCode,
      haveBoxBarcode,
      havePSkuUnique,
      haveItems,
      haveAreaCode,
      havePendingQty,
      havePicklistNr,
      haveCreatedAt,
      haveFulfilmentDate,
      haveOriginCountry,
      haveDestinationCountry,
      haveIsDelivered,
      haveInvoiceDate,
      haveShippedDate,
      haveApprovedQty,
      haveRejectedQty,
      haveUnidentifiedQty,
      haveQtyQCRejected,
      haveQtyExcess,

      haveTicketNr,
      haveDisputeType,
      haveClosedAt,
      haveDocNr,
      haveSlot,
      haveResolutionAmt,
      haveDisputeReason,

      havePartnerSkuUnique,
      haveTotal,
      haveReason,
      haveDamageQty,
      haveQtySoh,
      haveQtyVal,
      haveVal
    };

    return property;
  },

  getAppDomain(appName) {
    const host = window.location.host;
    const [subDomain, domain] = host.split(".");
    const isAlt = !!subDomain.split("-")[1];
    return `https://${appName}${isAlt ? "-alt" : ""}.${domain ||
      "noon"}.partners`;
  },
  getOrderUrl(orderNr, locale) {
    if (!orderNr) {
      return "/";
    } else {
      const orderUrl =
        "/" + (locale ? locale + "/" : "") + "account/orders" + "/" + orderNr;
      return orderUrl;
    }
  },
  getBrandUrl(brand) {
    if (!brand) {
      return "/";
    } else if (brand.url) {
      return brand.url;
    } else {
      return `/${brand}`;
    }
  },
  getCountryCode(locale) {
    locale = cookies.get("locale") || locale;
    const countryCode = locale
      ? locale.split("-")[1].toUpperCase()
      : CONFIG.DEFAULT_COUNTRY_CODE;
    //cookies.set('shippingCountryCode', countryCode, { path: '/', domain: CONFIG.COOKIE_DOMAIN });
    return countryCode;
  },
  getLocale() {
    let locale = "en-ae";
    try {
      locale = window.location.pathname
        .toLowerCase()
        .match(/\/(([a-z]{2}-[a-z]{2}))/)[1];
    } catch (e) {}
    return locale;
  },
  getLang() {
    let lang = "en";
    if (window) {
      const match = window.location.pathname
        .toLowerCase()
        .match(/\/(([a-z]{2}-))/);
      if (match && !_.isEmpty(match)) lang = match[1].replace(/-/g, "");
    }
    return lang;
  },
  getCountry() {
    let match = "-ae";
    if (window) {
      match = window.location.pathname.toLowerCase().match(/((-[a-z]{2}))/)[1];
    }
    return match.replace(/-/g, "");
  },
  toggleLanguage() {
    const url = document.URL.replace(/^(?:\/\/|[^\/]+)*\//, "/");
    const lang = url.indexOf("/ar") !== -1 ? "en-" : "ar-";
    this.setLang(lang);
  },
  toggleCountry(country) {
    const url = document.URL.replace(/^(?:\/\/|[^\/]+)*\//, "/");
    this.setRajyam(country);
  },
  setLang(lang) {
    cookies.set("lang", lang, { path: "/", domain: CONFIG.COOKIE_DOMAIN });
    cookies.set("locale", `${lang}-${this.getCountry()}`, {
      path: "/",
      domain: CONFIG.COOKIE_DOMAIN
    });
    window.location.href = window.location.href.replace(
      new RegExp(/\/(([a-z]{2}-))/),
      `/${lang}`
    );
  },
  setRajyam(country) {
    cookies.set("rajyam", country, { path: "/", domain: COOKIE_DOMAIN });
    cookies.set("locale", `${this.getLang()}-${country}`, {
      path: "/",
      domain: CONFIG.COOKIE_DOMAIN
    });
    // if (API && API.baseapi)
    // API.baseapi.setHeader(
    //   "X-Locale",
    //   `${this.getLang()}-${country && country.toLowerCase()}`
    // );

    window.location.href = window.location.href.replace(
      new RegExp(/((-[a-z]{2}))\//),
      `-${country}/`
    );
  },
  setLocaleCookie(locale) {
    cookies.set("lang", locale.lang, {
      path: "/",
      domain: CONFIG.COOKIE_DOMAIN
    });
    cookies.set("locale", locale.locale, {
      path: "/",
      domain: CONFIG.COOKIE_DOMAIN
    });
  },

  getUrlDomain() {
    let loc = 'noon.partners';
    if (process.browser && window) {
        loc = window.location.hostname
            .split('.')
            .slice(-2)
            .join('.');
    }
    return loc;
},
getUrlLocale() {
  let locale = 'en-ae';
  if (process.browser) {
      const path = window.location.pathname;
      [, locale] = path.split('/');
  }
  return locale.toLowerCase();
},
  getQueryParam(location, param) {
    if (!location) {
      return "";
    }
    const paramsString = location.search;
    const searchParams = URLSearchParams
      ? new URLSearchParams(paramsString)
      : "";
    return searchParams && searchParams.get(param);
  },
  round(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);

    return roundedTempNumber / factor;
  },
  ceil(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.ceil(tempNumber);

    return roundedTempNumber / factor;
  },
  floor(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.floor(tempNumber);

    return roundedTempNumber / factor;
  },
  setFSUser(user) {
    if (window && window.FS) {
      try {
        window.FS.identify(user.id, {
          displayName: user.firstName + " " + user.lastName,
          email: user.email
        });
      } catch (err) {
        Raven.captureException(err, {
          component: "Helper",
          function: "setFSUser"
        });
      }
    }
  }
};

export default Helper;



// WEBPACK FOOTER //
// ./src/helper/Helper.js